import React from 'react'
import Image from 'next/image'
import { Container } from '../Container'

type Props = {
  imagePath: string
  title: string
}
export const BlogTitleSection: React.FC<Props> = ({ title, imagePath }) => (
  <section className="py-0">
    <div
      className="flex flex-col justify-center align-center"
      style={{ height: '60vh', position: 'relative', width: '100%' }}
    >
      <Image
        src={imagePath}
        priority={true}
        alt={`NuBrakes Blog ${title} Image`}
        layout={'fill'}
        objectFit="cover"
        objectPosition="bottom center"
      />
      <div
        id="overlay"
        style={{
          minHeight: '100%',
          width: '100%',
          position: 'absolute',
          zIndex: 1,
          backgroundColor: 'rgba(72, 72, 72, 0.74)',
        }}
      />
      <div style={{ zIndex: 2 }}>
        <Container>
          <div className="flex flex-col justify-center">
            <h1 className="title text-center text-white ">{title}</h1>
          </div>
        </Container>
      </div>
    </div>
  </section>
)
